import http from '@/util/http';

export default {
	getRatePlanSimulation() {
		return http.get('RatePlanSimulation/api/getRatePlanSimulation');
	},
}


// WEBPACK FOOTER //
// ./src/api/ratePlanSimulation/ratePlanSimulationApi.js